import { catanAddOnCode } from 'aa/vue/constants/aaBundle';

export const AARP_ENABLED = 'aarp_enabled';
export const AA_DYNAMIC_AGREEMENT_COPY = 'aa_dynamic_agreement_copy';
export const AA_PAYPAL = 'aa_paypal';
export const AA_PURCHASE_REVIEW_SCREEN = 'aa_purchase_review_screen';
// START feature/PPIWEBM-1594
export const AB_TEST_BEST_PLAN_RECOMMENDED = 'exp_web_intl_best_plan_recommended_ca_mx_br';
export const AB_TEST_BEST_PLAN_RECOMMENDED_WITH_SAVE_STRING =
    'exp_web_intl_best_plan_recommended_uk_it_gsa';
// END feature/PPIWEBM-1594
export const AGE_GATE = 'age_gate_enabled';
export const AUTHSUITE_ENABLED = 'authsuite_enabled';
export const CAMPAIGN_SERVICE_ENABLED = 'campaign_service_enabled';
export const CONTINUE_FREE_TRIAL = 'continue_free_trial';
export const COLD_START_PREMIUM_LOCKS_ENABLED = 'cold_start_premium_locks_enabled';
export const CONTINUOUS_PLAY = 'continuous_play';
export const DIRECT_LINK = 'direct_link';
export const DISPLAY_RETENTION_OFFER = 'display_retention_offer';
export const EMAIL_VERIFICATION_ENABLED = 'email_verification_enabled';
export const ENHANCED_KIDS_PRIVACY_ENABLED = 'enhanced_kids_privacy_enabled';
export const ENHANCED_PAYMENT_SUMMARY_ENABLED = 'enhanced_payment_summary_enabled';
export const FORCE_ANNUAL_GIFT_CARD = 'force_annual_gift_card';
export const GIFT_SHIPPING_INFO_ENABLED = 'gift_shipping_info_enabled';
export const MFE_ENABLED = 'mfe_enabled';
export const MFE_USERPROFILES_ENABLED = 'mfe_userprofiles_enabled';
export const MULTI_SUB_PLAN_PICKER_ENABLED = 'multi_sub_plan_picker_enabled';
export const MVPD_SIGN_IN_HTML5_ENABLED = 'mvpd_sign_in_html5_enabled';
export const PAYMENT_METHOD_EDIT_SP = 'paymentmethodedit_sp';
export const PAYMENT_SUMMARY_CHANGE_LINK_ENABLED = 'payment_summary_change_link_enabled';
export const PAYPAL_EDIT_PAYMENT_ENABLED = 'paypal_edit_payment_enabled';
export const PICK_A_PLAN_COPY_FLEXIBILITY_ENABLED = 'pick_a_plan_copy_flexibility_enabled';
export const PLANPICKER_COMPLIANCE_ENABLED = 'planpicker_compliance_enabled';
export const PRICE_WITH_ASTERISK = 'PRICE_WITH_ASTERISK';
export const REDFAST_ENABLED = 'redfast_enabled';
export const REDFAST_PREMIUM_UPSELL_ENABLED = 'redfast_premium_upsell_enabled';
export const RESELLER_DELTA_AUTO_LOGIN = 'reseller_delta_auto_login';
export const RESELLER_DELTA_DEPEVIEW = 'reseller_delta_deepview';
export const RESELLER_DELTA_JOURNEY = 'reseller_delta_journey';
export const RESELLER_DELTA_JOURNEY_SIGN_IN = 'reseller_delta_journey_sign_in';
export const RESELLER_DELTA_JOURNEY_SIGN_UP = 'reseller_delta_journey_sign_up';
export const SCREENTIME_LIMIT_ENABLED = 'screentime_limit_enabled';
export const SHOWTIME_BANNER_ENABLED = 'walmartplus_success_showtime_banner_enabled';
export const SHOWTIME_INTEGRATION_ENABLED = 'showtime_integration_enabled';
export const WEB_US_PLANS_REFACTOR_INITIAL_SUBSEQUENT_ENABLED =
    'web_us_plans_refactor_initial_subsequent_enabled';
export const SHOW_PICKER = 'show_picker';
export const SKIP_EXPLAINER_STEPS = 'skip_explainer_steps';
export const PLAN_HEADER_COPY_CHANGE = 'plan_header_copy_change';
export const SWITCH_PLAN_ENABLED = 'switch_plan_enabled';
export const TN_SIGNIN_DEFAULT_ENABLED = 'tn_signin_default_enabled';
export const REMOVE_COUPON_ON_SWITCH_PLAN = 'remove_coupon_on_switch_plan';
export const SWITCH_PROFILE_PIN_ENABLED = 'switch_profile_pin_enabled';
export const TOKEN_EXPIRED = 'Unable to validate token reason: Token is not valid';
export const USER_PROFILES = 'user_profiles';
export const WAIVE_COOLING_RIGHTS_ENABLED = 'waive_cooling_rights_enabled';
export const SWITCH_PLAN_WAIVE_COOLING_RIGHTS_ENABLED = 'switch_plan_waive_cooling_rights_enabled';
export const WALMART_PLUS_CONSENT = 'walmart_plus_consent';
export const WEB_RENDEZVOUS_MVPD_ENABLED = 'web_rendezvous_mvpd_enabled';
export const SUBSEQUENT = 'SUBSEQUENT';
export const WEB_SIGN_IN_MVPD_ENABLED = 'web_sign_in_mvpd_enabled';
export const WEB_SIGN_OUT_INDIVIDUAL_DEVICES_ENABLED = 'web_sign_out_individual_devices';
export const WEB_RENDEZVOUS_SINGLE_URL_ENABLED = 'web_rendezvous_single_url_enabled';
export const GIFTCARD_TDS = 'giftcard_tds';
// START feature/PPIWEBM-2028
export const AB_TEST_ANNUAL_PLAN_HIGHLIGHT = 'web_annual_plan_highlight';
export const AB_TEST_ANNUAL_PLAN_HIGHLIGHT_ALL = 'emphasis_icon_and_green_pill';
export const AB_TEST_ANNUAL_PLAN_HIGHLIGHT_ICON_AND_GREEN_PILL = 'icon_and_green_pill';
export const AB_TEST_ANNUAL_PLAN_HIGHLIGHT_GREEN_PILL = 'green_pill';
// END feature/PPIWEBM-2028
export const CANCELLATION_SURVEY_RANDOMIZED_ENABLED = 'cancellation_survey_randomized_enabled';
// START feature/PPIWEBM-2064
export const EXP_AB_TEST_INTL_NO_FREE_TRIAL = 'exp_web_intl_no_free_trial';
export const AB_TEST_INTL_NO_FREE_TRIAL = 'web_intl_no_free_trial';
export const AB_TEST_INTL_NO_FREE_TRIAL_VARIANT = 'no_trial';
// END feature/PPIWEBM-2064
export const FTC_COMPLIANCE_ENABLED = 'ftc_compliance_enabled';
export const FTC_COMPLIANCE_PICKAPLAN_ENABLED = 'ftc_compliance_pickaplan_enabled';
export const FTC_COMPLIANCE_UPSELL_ENABLED = 'ftc_compliance_upsell_enabled';
export const FTC_COMPLIANCE_SWITCHPLAN_ENABLED = 'ftc_compliance_switchplan_enabled';
export const FTC_COMPLIANCE_CHECKBOX_ENABLED = 'ftc_compliance_checkbox_enabled';
export const FTC_COMPLIANCE_COUPON_REDEEM_ENABLED = 'ftc_compliance_coupon_redeem_enabled';
export const WEB_CANCEL_SAVE_FTC_ENABLED = 'web_cancel_save_ftc_enabled';
export const USE_HIDDEN_BILLING_RULES_CHECKBOX = 'use_hidden_billing_rules_checkbox';
export const WEB_BILLING_ENABLED = 'web_billing_enabled';
// START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
export const ALLACCESS_LCP_MONTHLY = 'allaccess_lcp_monthly';
export const ALLACCESS_AD_FREE_MONTHLY = 'allaccess_ad_free_monthly';
export const ALLACCESS_LCP_ANNUAL = 'allaccess_lcp_annual';
export const ALLACCESS_AD_FREE_ANNUAL = 'allaccess_ad_free_annual';
// END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
export const RECURLY_KOUNT_FRAUD_DETECTION_ENABLED = 'web_recurly_kount_integration';

// Flag OFF (default) => checkbox is shown. Flag ON => checkbox is removed.
export const MARKETING_CHECKBOX_REMOVAL_ENABLED = 'marketing_checkbox_enabled';

export const PICK_PLAN_TIER_PRESELECTION_ENABLED = 'pick_plan_tier_preselection_enabled';
export const EXP_WEB_INTL_SINGLE_COLUMN_PAYMENT = 'exp_web_intl_single_column_payment';
export const SINGLE_COLUMN_PAYMENT_PAGE = 'single_column_payment_page';
export const COUPON_PREVIEW_ENABLED = 'coupon_preview_enabled';
export const UNIFIED_IDENTITY_PLATFORM = 'unified_identity_platform';

export const FeatureKeys = {
    AARP_ENABLED: AARP_ENABLED,
    AA_DYNAMIC_AGREEMENT_COPY: AA_DYNAMIC_AGREEMENT_COPY,
    AA_PAYPAL: AA_PAYPAL,
    AA_PURCHASE_REVIEW_SCREEN: AA_PURCHASE_REVIEW_SCREEN,
    CAMPAIGN_SERVICE_ENABLED,
    COLD_START_PREMIUM_LOCKS_ENABLED: COLD_START_PREMIUM_LOCKS_ENABLED,
    CONTINUOUS_PLAY: CONTINUOUS_PLAY,
    EMAIL_VERIFICATION_ENABLED: EMAIL_VERIFICATION_ENABLED,
    ENHANCED_KIDS_PRIVACY_ENABLED: ENHANCED_KIDS_PRIVACY_ENABLED,
    ENHANCED_PAYMENT_SUMMARY_ENABLED: ENHANCED_PAYMENT_SUMMARY_ENABLED,
    FORCE_ANNUAL_GIFT_CARD: FORCE_ANNUAL_GIFT_CARD,
    GIFT_SHIPPING_INFO_ENABLED: GIFT_SHIPPING_INFO_ENABLED,
    MFE_ENABLED: MFE_ENABLED,
    MFE_USERPROFILES_ENABLED: MFE_USERPROFILES_ENABLED,
    MULTIPLE_ENTITLEMENTS_ENABLED: 'multiple_entitlements_enabled',
    MULTI_SUB_PLAN_PICKER_ENABLED: MULTI_SUB_PLAN_PICKER_ENABLED,
    MVPD_SIGN_IN_HTML5_ENABLED: MVPD_SIGN_IN_HTML5_ENABLED,
    PAYMENT_METHOD_EDIT_SP: PAYMENT_METHOD_EDIT_SP,
    PAYMENT_SUMMARY_CHANGE_LINK_ENABLED: PAYMENT_SUMMARY_CHANGE_LINK_ENABLED,
    PAYPAL_EDIT_PAYMENT_ENABLED: PAYPAL_EDIT_PAYMENT_ENABLED,
    PLANPICKER_COMPLIANCE_ENABLED: PLANPICKER_COMPLIANCE_ENABLED,
    PRICE_WITH_ASTERISK: PRICE_WITH_ASTERISK,
    REDFAST_ENABLED: REDFAST_ENABLED,
    REDFAST_PREMIUM_UPSELL_ENABLED: REDFAST_PREMIUM_UPSELL_ENABLED,
    SCREENTIME_LIMIT_ENABLED: SCREENTIME_LIMIT_ENABLED,
    SHOWTIME_INTEGRATION_ENABLED: SHOWTIME_INTEGRATION_ENABLED,
    SHOW_PICKER: SHOW_PICKER,
    SWITCH_PLAN_ENABLED: SWITCH_PLAN_ENABLED,
    REMOVE_COUPON_ON_SWITCH_PLAN: REMOVE_COUPON_ON_SWITCH_PLAN,
    SWITCH_PROFILE_PIN_ENABLED: SWITCH_PROFILE_PIN_ENABLED,
    TOKEN_EXPIRED: TOKEN_EXPIRED,
    USER_PROFILES: USER_PROFILES,
    WEB_RENDEZVOUS_MVPD_ENABLED: WEB_RENDEZVOUS_MVPD_ENABLED,
    WEB_RENDEZVOUS_SINGLE_URL_ENABLED: WEB_RENDEZVOUS_SINGLE_URL_ENABLED,
    WEB_SIGN_IN_MVPD_ENABLED: WEB_SIGN_IN_MVPD_ENABLED,
    WEB_SIGN_OUT_INDIVIDUAL_DEVICES_ENABLED: WEB_SIGN_OUT_INDIVIDUAL_DEVICES_ENABLED,
    WEB_CANCEL_SAVE_FTC_ENABLED: WEB_CANCEL_SAVE_FTC_ENABLED,
    GIFTCARD_TDS,
    MARKETING_CHECKBOX_REMOVAL_ENABLED: MARKETING_CHECKBOX_REMOVAL_ENABLED,
};

export default class Feature {
    static enabled(key) {
        return CBS.Registry.Features?.[key];
    }

    static multipleEntitlementsEnabled() {
        return this.enabled(FeatureKeys.MULTIPLE_ENTITLEMENTS_ENABLED);
    }

    /**
     * Checks if the partner bundle feature is enabled.
     * @returns {boolean} True if the partner bundle feature is enabled, false otherwise.
     */
    static partnerBundleEnabled() {
        return this.enabled(`${catanAddOnCode().toLowerCase()}_bundle_enabled`);
    }

    /**
     * Checks if the web rendezvous mvpd feature is enabled.
     *
     * @returns {boolean} True if web rendezvous mvpd feature is enabled, false otherwise.
     */
    static webRendezvousMvpdEnabled() {
        return this.enabled(FeatureKeys.WEB_RENDEZVOUS_MVPD_ENABLED);
    }

    static mvpdSignInHtml5Enabled() {
        return this.enabled(FeatureKeys.MVPD_SIGN_IN_HTML5_ENABLED);
    }

    static webSignOutIndividualDevicesEnabled() {
        return this.enabled(FeatureKeys.WEB_SIGN_OUT_INDIVIDUAL_DEVICES_ENABLED);
    }
}
